import CongresOverlay from '@/components/congres-overlay';
import ContentLayout from '@/components/layout/ContentLayout';
import { QuizCarousel } from '@/components/quiz-carousel';
import MobileLandscapeAnswer, { useMobileLandscape } from '@/components/mobile-landscape-answer';
import { ROUTE } from '@/routes/constants';
import { getQuestionList } from '@/services/generatedAPIs';
import { GetQuestionListResponse } from '@/services/generatedAPIs.schemas';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

interface PageState {
  assignmentId: number;
  studentId: number;
}

const PracticeEditPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const locationState = useLocation().state;
    const [pageState, setPageState] = React.useState<PageState | null>(null);
    const [questionListResponse, setQuestionListResponse] = React.useState<GetQuestionListResponse>();
    const [showCongres, setShowCongres] = React.useState(false);
    const isMobileLandscape = useMobileLandscape();
    // 入口模块标题键 (更多習題 / 錯題重練 / 自由主題); 未带回退到 隨心練
    const titleKey: string = locationState?.titleKey ?? 'student.practice';

    // Initialize component state from router location state once
    React.useEffect(() => {
      if (!locationState?.assignmentId || !locationState?.studentId) {
        console.error('Missing required state parameters: assignmentId or studentId');
        navigate(ROUTE.STUDENT.PRACTICE_HOME);
        return;
      }
      if (!pageState) {
        setPageState({
          assignmentId: locationState.assignmentId,
          studentId: locationState.studentId,
        });
      }
    }, [locationState, pageState, navigate]);

    React.useEffect(() => {
       if (!pageState) return;
       // Only fetch if not already loaded
       if (!questionListResponse) {
         getQuestionList({ assignmentId: pageState.assignmentId, studentId: pageState.studentId, newest: true }).then((rsp) => {
              if (rsp.code === 200 && rsp.data) {
                setQuestionListResponse(rsp.data);
              } else {
                console.log('Error getQuestionList', rsp)
              }
          }).catch((e) => {
            console.log('Error getQuestionList', e)
          });
       }
    }, [pageState, questionListResponse]);

    // overlay:两态共用,只渲染一份
    const overlays = (
        <CongresOverlay
            isLoading={showCongres}
            text={t('student.congresFinished')}
            onNavigate={() => navigate(ROUTE.STUDENT.PRACTICE_HOME)}
            buttonText={t('component.backToPractice')}
        />
    );

    // 答题主体:桌面/横屏共享的同一段 JSX(同一时刻只渲染一棵树 → QuizCarousel 只挂一份)
    const answerBody = (pageState && questionListResponse && questionListResponse.questionModelList.length > 0) && <QuizCarousel key={questionListResponse.assignmentId!} quizProps={{
        assignmentId: questionListResponse.assignmentId,
        questionModelList: questionListResponse.questionModelList,
        assignmentStat: questionListResponse.assignmentStat
       }} readonly={false} onFinish={() => {
        setShowCongres(true);
       }}></QuizCarousel>;

    if (isMobileLandscape) {
      return (
        <>
          {overlays}
          <MobileLandscapeAnswer title={t(titleKey)}>{answerBody}</MobileLandscapeAnswer>
        </>
      );
    }

    return (
        <ContentLayout title={t(titleKey)} backgroundColor="var(--practice-page-bg)" className="md:h-full md:overflow-hidden">
            {overlays}
            {/* lg/xl 左 padding 对齐 2xl 的 pl-0(内容贴近侧栏,gap≈24)；2xl/1920 不变 */}
            <div className="mx-auto w-full max-w-[2000px] px-6 pt-6 pb-6 lg:pl-0 lg:pr-6 2xl:pl-0 2xl:pr-6 min-[1920px]:max-w-none min-[1920px]:px-6 md:flex md:min-h-0 md:flex-1 md:flex-col">
                <div className="rounded-[30px] bg-[#F3F3F4] p-6 lg:p-10 xl:rounded-[38px] 2xl:ml-auto 2xl:w-full 2xl:max-w-[1433px] 2xl:rounded-[44px] min-[1920px]:max-w-none! min-[1920px]:rounded-[50px]! md:min-h-0 md:flex-1 md:overflow-y-auto">
                   {answerBody}
                </div>
            </div>
        </ContentLayout>
    );
};

export default PracticeEditPage;
